"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var helpers_1 = require("../../helpers");
var styles_1 = require("../../helpers/styles");
var Interactor_1 = require("./Interactor");
var InputControl_1 = require("../helpers/InputControl");
var controls_1 = require("./..");
var InputBox_1 = require("../helpers/InputBox");
var useControlState_1 = require("../helpers/useControlState");
var public_1 = require("../../common/public");
var helpers_2 = require("./helpers");
var SVG = __importStar(require("./svg"));
exports.MIN_WIDTH_NUMBER_INPUT = '57px';
var SPEED = 50;
var DELAY = 500;
var DIRECTION;
(function (DIRECTION) {
    DIRECTION["Up"] = "up";
    DIRECTION["Down"] = "down";
})(DIRECTION || (DIRECTION = {}));
var INT_BUTTON_WIDTH = parseInt(helpers_1.SPACING_XL, 10) - 2 * parseInt(helpers_1.BASE_BORDER_WIDTH, 10);
var StyledArrow = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex: 1;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n    width: 100%;\n\n    ", "\n"], ["\n    display: flex;\n    flex: 1;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n    width: 100%;\n\n    ",
    "\n"])), function (_a) {
    var isDisabled = _a.isDisabled, isError = _a.isError;
    return isDisabled
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                  pointer-events: none;\n              "], ["\n                  pointer-events: none;\n              "]))) : styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                  &:hover {\n                      background-color: ", ";\n                  }\n\n                  &:active {\n                      background-color: ", ";\n                  }\n              "], ["\n                  &:hover {\n                      background-color: ",
        ";\n                  }\n\n                  &:active {\n                      background-color: ",
        ";\n                  }\n              "])), function (props) {
        return isError
            ? props.theme.colorHighlightErrorLight
            : props.theme.colorHighlightLight;
    }, function (props) {
        return isError
            ? props.theme.colorHighlightErrorDark
            : props.theme.colorHighlightDark;
    });
});
var ArrowButton = function (_a) {
    var direction = _a.direction, onMouseDown = _a.onMouseDown, onMouseLeave = _a.onMouseLeave, isDisabled = _a.isDisabled, isError = _a.isError, rest = __rest(_a, ["direction", "onMouseDown", "onMouseLeave", "isDisabled", "isError"]);
    return (react_1.default.createElement(StyledArrow, { "data-selector-id": rest['data-selector-id'] + "-" + direction, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, isDisabled: isDisabled, isError: isError },
        direction === DIRECTION.Up && (react_1.default.createElement(SVG.ArrowUpSVGIcon, { isDisabled: isDisabled, isError: isError })),
        direction === DIRECTION.Down && (react_1.default.createElement(SVG.ArrowDownSVGIcon, { isDisabled: isDisabled, isError: isError }))));
};
var UpDownStyled = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n"], ["\n    width: ", "px;\n    height: ", "px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n"])), INT_BUTTON_WIDTH, INT_BUTTON_WIDTH);
var ArrowButtons = function (_a) {
    var handleUp = _a.handleUp, handleDown = _a.handleDown, isDisabled = _a.isDisabled, isError = _a.isError, onArrowLeave = _a.onArrowLeave, rest = __rest(_a, ["handleUp", "handleDown", "isDisabled", "isError", "onArrowLeave"]);
    return (react_1.default.createElement(UpDownStyled, null,
        react_1.default.createElement(ArrowButton, { onMouseLeave: onArrowLeave, "data-selector-id": rest['data-selector-id'], direction: DIRECTION.Up, onMouseDown: function (e) {
                if (e.button === 0) {
                    handleUp(e);
                    return;
                }
                onArrowLeave === null || onArrowLeave === void 0 ? void 0 : onArrowLeave(e);
            }, isDisabled: isDisabled, isError: isError }),
        react_1.default.createElement(ArrowButton, { onMouseLeave: onArrowLeave, "data-selector-id": rest['data-selector-id'], direction: DIRECTION.Down, onMouseDown: function (e) {
                if (e.button === 0) {
                    handleDown(e);
                    return;
                }
                onArrowLeave === null || onArrowLeave === void 0 ? void 0 : onArrowLeave(e);
            }, isDisabled: isDisabled, isError: isError })));
};
var Wrapper = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    box-sizing: border-box;\n    position: relative;\n    width: ", ";\n    min-width: ", ";\n    height: ", ";\n\n    ", " {\n        position: absolute;\n        top: ", ";\n        right: ", ";\n    }\n"], ["\n    box-sizing: border-box;\n    position: relative;\n    width: ", ";\n    min-width: ", ";\n    height: ", ";\n\n    ", " {\n        position: absolute;\n        top: ", ";\n        right: ", ";\n    }\n"])), function (_a) {
    var size = _a.size;
    return size;
}, exports.MIN_WIDTH_NUMBER_INPUT, helpers_1.SPACING_XL, UpDownStyled, helpers_1.BASE_BORDER_WIDTH, helpers_1.BASE_BORDER_WIDTH);
Wrapper.displayName = 'Wrapper';
var StyledInputControl = styled_components_1.default(InputControl_1.InputControl)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: 0 ", ";\n"], ["\n    padding: 0 ", ";\n"])), helpers_1.SPACING_S);
var StyledInputBox = styled_components_1.default(InputBox_1.InputBox)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    min-width: ", ";\n"], ["\n    min-width: ", ";\n"])), exports.MIN_WIDTH_NUMBER_INPUT);
exports.NumberInput = helpers_1.createUIElement('NumberInput', function (_a, ref) {
    var className = _a.className, value = _a.value, _b = _a.step, step = _b === void 0 ? 1 : _b, _c = _a.minValue, minValue = _c === void 0 ? Number.MIN_SAFE_INTEGER : _c, _d = _a.maxValue, maxValue = _d === void 0 ? Number.MAX_SAFE_INTEGER : _d, _e = _a.hasArrows, hasArrows = _e === void 0 ? true : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.error, error = _g === void 0 ? false : _g, _h = _a.size, size = _h === void 0 ? public_1.CONTROL_SIZE.xxs : _h, maxLength = _a.maxLength, _j = _a.allowDecimal, allowDecimal = _j === void 0 ? false : _j, _k = _a.precision, precision = _k === void 0 ? 2 : _k, onChange = _a.onChange, onValidationError = _a.onValidationError, _l = _a.arrowDelayInMs, arrowDelayInMs = _l === void 0 ? DELAY : _l, _m = _a.arrowSpeedInMs, arrowSpeedInMs = _m === void 0 ? SPEED : _m, _o = _a.hasEnterKeyStopPropagation, hasEnterKeyStopPropagation = _o === void 0 ? false : _o, onFocus = _a.onFocus, onBlur = _a.onBlur, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "value", "step", "minValue", "maxValue", "hasArrows", "disabled", "error", "size", "maxLength", "allowDecimal", "precision", "onChange", "onValidationError", "arrowDelayInMs", "arrowSpeedInMs", "hasEnterKeyStopPropagation", "onFocus", "onBlur", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var timer = react_1.useState({ current: 0 })[0];
    var config = { allowDecimal: allowDecimal, precision: precision, maxLimit: maxValue, minLimit: minValue };
    var _p = useControlState_1.useControlState({
        rootRef: ref
    }), focused = _p.focused, active = _p.active, input = _p.input;
    var listener = react_1.useState({
        onValidationError: function () { },
        onChange: function () { },
        onDraftValueChange: function () { }
    })[0];
    var _q = react_1.useState(''), draftValue = _q[0], setDraft = _q[1];
    var inputEl = react_1.useRef(null);
    var valueState = helpers_1.useStateValue(value, [value], {
        onChange: onChange
    });
    listener.onChange = valueState.setValue;
    listener.onDraftValueChange = setDraft;
    listener.onValidationError = onValidationError;
    var interactor = react_1.useState(new Interactor_1.NumberInputInteractor(valueState.getValue(), { allowDecimal: allowDecimal, precision: precision, maxLimit: maxValue, minLimit: minValue }, listener))[0];
    var clearTimer = function () {
        if (timer.current) {
            clearTimeout(timer.current);
        }
    };
    helpers_1.useStateValue(config, [config], {
        onReset: function (nextValue) {
            interactor.setConfig(nextValue);
        }
    });
    react_1.useEffect(function () {
        if (value !== interactor.getValue()) {
            interactor.change(value);
        }
    }, [value]);
    react_1.useEffect(function () {
        return function () {
            clearTimer();
        };
    }, []);
    var handleKeyDown = function (e) {
        if (e.keyCode === helpers_1.KeyCode.UpArrow) {
            e.preventDefault();
            e.stopPropagation();
            interactor.add(step);
        }
        if (e.keyCode === helpers_1.KeyCode.DownArrow) {
            e.preventDefault();
            e.stopPropagation();
            interactor.add(step * -1);
        }
    };
    var handleMouseDown = function (direction) {
        if (inputEl && inputEl.current) {
            inputEl.current.focus();
        }
        var addValue = direction === DIRECTION.Up ? step : step * -1;
        interactor.add(addValue);
        clearTimer();
        timer.current = window.setTimeout(function () {
            clearTimer();
            timer.current = window.setInterval(function () {
                interactor.add(addValue);
            }, arrowSpeedInMs);
        }, arrowDelayInMs);
    };
    var dataSelectorId = rest['data-selector-id'] || 'number-input';
    var currentValue = valueState.getValue();
    var inputValue = typeof currentValue === 'number'
        ? helpers_2.truncateNumber(currentValue, { precision: allowDecimal ? precision : undefined })
        : '';
    if (draftValue) {
        inputValue = draftValue;
    }
    var rightAddon = hasArrows ? (react_1.default.createElement(ArrowButtons, { "data-selector-id": dataSelectorId + "-arrow", isDisabled: disabled, isError: error, onArrowLeave: clearTimer, handleUp: function (e) {
            e.preventDefault();
            handleMouseDown(DIRECTION.Up);
        }, handleDown: function (e) {
            e.preventDefault();
            handleMouseDown(DIRECTION.Down);
        } })) : null;
    return (react_1.default.createElement(StyledInputBox, __assign({}, rest, { "data-selector-id": dataSelectorId, className: "vm-NumberInput " + className, "data-error-state": error ? true : undefined, tabIndex: -1, size: typeof size === 'string' ? size : styles_1.calcWidth(size), isFocused: focused, isActive: active, isDisabled: disabled, hasError: error, rightAddon: rightAddon, hasSpacing: false, onMouseUp: clearTimer, onFocus: function (e) {
            input.onFocus(e);
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        }, onBlur: function (e) {
            input.onBlur(e);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(StyledInputControl, { "data-selector-id": dataSelectorId + "-text-input", ref: inputEl, value: inputValue !== undefined ? String(inputValue) : undefined, disabled: disabled, type: controls_1.INPUT_TYPE.text, maxLength: maxLength, hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, onKeyDown: handleKeyDown, onChange: function (e) {
                interactor.changeByText(e.target.value);
            }, onBlur: function () {
                if (draftValue) {
                    setDraft('');
                }
            } })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=NumberInput.js.map